import { PANEL, INTERACTION } from '@tmapy/config';
import { actionSetPanel } from '@tmapy/ui-manager';
import { actionSetInteraction } from '@tmapy/mapcore';
import { SET_TAB, SET_TAB_VALUE, SET_SEARCH_STATE } from './constants';
export const actionActivateSearch = () => (dispatch) => {
    dispatch(actionSetPanel(PANEL.SEARCH));
};
export const actionDeactivateSearch = () => (dispatch) => {
    dispatch(actionSetInteraction({ type: INTERACTION.NONE }));
    dispatch(actionSetPanel(PANEL.NONE));
};
export const actionSetSearchState = (payload) => ({
    type: SET_SEARCH_STATE,
    payload,
});
export const actionSetTab = (activeTabId) => ({
    type: SET_TAB,
    payload: activeTabId,
});
export const actionSetTabValue = (payload) => ({
    type: SET_TAB_VALUE,
    payload,
});
//# sourceMappingURL=actions.js.map